import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, CircularProgress, Link as MuiLink, Popover, useMediaQuery, useTheme } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import KeyIcon from '@mui/icons-material/Key';
import SecurityIcon from '@mui/icons-material/Security';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useDispatch, useSelector } from 'react-redux';
// import { connectUPS, disconnectUPS } from '../../../redux/actions/upsActions';
import { validateToken } from '../../../redux/actions/validateAction';
import {
  Extension as ExtensionIcon,
} from '@mui/icons-material';
import upsicon from '../../../images/UPS.png';
import { getUserById } from '../../../redux/actions/userActions';

const UPSIntegration = ({ selectedUserId, selectedUser }) => {
  const dispatch = useDispatch();
  const { connected } = useSelector((state) => state.ups);
  const { byId: userById } = useSelector((state) => state.users);
  const userLoading = Boolean(userById?.loading);
  
  const authUser = useSelector((state) => state.auth?.user);
  const fallbackSelectedPayload = userById?.data?.data || userById?.data;
  const fallbackSelected = fallbackSelectedPayload?.user || fallbackSelectedPayload;
  const effectiveUser = selectedUserId ? (selectedUser || fallbackSelected) : authUser;
  const isLinkedInAuth = !!(effectiveUser && effectiveUser.ups && (effectiveUser.ups.clientId || effectiveUser.ups.connectedAt));
  const isConnected = connected || isLinkedInAuth;
  const [open, setOpen] = useState(false);
  const [infoAnchor, setInfoAnchor] = useState(null);
  const [form, setForm] = useState({ clientId: '', clientSecret: '' });
  const [errors, setErrors] = useState({});
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [showDetailsId, setShowDetailsId] = useState(false);
  const [showDetailsSecret, setShowDetailsSecret] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleOpen = () => { setOpen(true); setErrors({}); setForm({ clientId: '', clientSecret: '' }); };
  const handleClose = () => setOpen(false);
  const handleInfoOpen = (e) => setInfoAnchor(e.currentTarget);
  const handleInfoClose = () => setInfoAnchor(null);
  const infoOpen = Boolean(infoAnchor);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const onChange = (field) => (e) => setForm((p) => ({ ...p, [field]: e.target.value }));

  const validate = () => {
    const e = {};
    if (!form.clientId.trim()) e.clientId = 'Client ID is required';
    if (!form.clientSecret.trim()) e.clientSecret = 'Client Secret is required';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  // const onSubmit = async () => {
  //   if (!validate()) return;
  //   const res = await dispatch(connectUPS({ clientId: form.clientId, clientSecret: form.clientSecret }));
  //   if (res?.success) {
  //     setOpen(false);
  //     dispatch(validateToken());
  //   }
  // };

  return (
    <Box>
        <Card
        elevation={2}
        sx={{
          borderRadius: 2,
          bgcolor: '#ffffff',
          border: '1px solid #e5e7eb',
          height: '100%',
          minHeight: 350,
          cursor: isConnected ? 'default' : 'pointer',
          '&:hover': !isConnected ? { boxShadow: 4, borderColor: '#6b7280' } : {},
          transition: 'all 0.2s ease-in-out',
        }}
        onClick={!isConnected ? handleOpen : undefined}
      >
        <CardContent sx={{ p: 4, textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box>
            <Box sx={{ width: 64, height: 64, borderRadius: '50%', bgcolor: connected ? '#f0fdf4' : '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 3, border: connected ? '2px solid #bbf7d0' : 'none' }}>
              {/* <LocalShippingIcon sx={{ fontSize: 32, color: isConnected ? '#16a34a' : '#6b7280' }} /> */}
              <img src={upsicon} alt="UPS" style={{ width: 64, height: 64 }} />
            </Box>
            <Typography variant="h6" sx={{ 
              fontWeight: 600, 
              mb: 2, 
              color: isConnected ? '#16a34a' : '#111827',
            }}>
              UPS
            </Typography>
          </Box>

          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            {userLoading ? (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                <CircularProgress size={22} />
              </Box>
            ) : isConnected ? (
              <>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, bgcolor: '#f0fdf4', borderRadius: 2, border: '2px solid #bbf7d0' }}>
                  <Typography variant="body2" sx={{ color: '#15803d', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Connected
                  </Typography>
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                  <Button variant="text" size="small" onClick={() => setDetailsOpen(true)} sx={{ color: '#6b7280', '&:hover': { backgroundColor: '#f3f4f6' }}}>View Connection Details</Button>
                </Box>
                {/* Disconnect removed per requirements */}
              </>
            ) : (
              <>
                <Typography variant="body2" sx={{ mb: 2, color: '#6b7280' }}>
                  UPS is a shipping carrier service that integrates to coordinate shipping to all regions
                </Typography>
                <Typography variant="body2" sx={{ color: '#6b7280' }}>
                  Click to configure UPS integration settings
                </Typography>
              </>
            )}
          </Box>
        </CardContent>
      </Card>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2,
          borderBottom: '1px solid #e5e7eb',
          pb: 2,
          mb: 0
        }}>
          <Box sx={{ 
            width: 40, 
            height: 40, 
            borderRadius: '50%', 
            bgcolor: '#111827',
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center'
          }}>
            <ExtensionIcon sx={{ fontSize: 20, color: '#ffffff' }} />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, flex: 1 }}>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Configure UPS Integration
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#6b7280' }}>
                  Get your UPS Client ID & Secret
                </Typography>
                <IconButton size="small" onClick={handleInfoOpen} sx={{ color: '#6b7280' }}>
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Box>
            </Box>
          </Box>

          <Popover
            open={infoOpen}
            anchorEl={infoAnchor}
            onClose={handleInfoClose}
            anchorOrigin={{ vertical: isMobile ? 'bottom' : 'center', horizontal: isMobile ? 'center' : 'right' }}
            transformOrigin={{ vertical: isMobile ? 'top' : 'center', horizontal: isMobile ? 'center' : 'left' }}
            sx={{ '& .MuiPaper-root': { p: 2, maxWidth: isMobile ? 'calc(100vw - 32px)' : 420, width: isMobile ? 'calc(100vw - 32px)' : 'auto' } }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
              Get your UPS Client ID & Secret
            </Typography>
            <Typography variant="body2" sx={{ color: '#374151', mb: 1 }}>
              1. Log in to the{' '}
              <MuiLink href="https://developer.ups.com" target="_blank" rel="noreferrer">
                UPS Developer Portal
              </MuiLink>.
            </Typography>
            <Typography variant="body2" sx={{ color: '#374151' }}>
              2. Go to <strong>My Apps → Add Apps</strong>.
              <br />3. On the first screen:
              <ul style={{ marginTop: 6, paddingLeft: 18 }}>
                <li>Select “I want to integrate UPS technology into my business.”</li>
                <li>Choose your UPS account from the dropdown.</li>
                <li>Check the box to agree to the UPS API Access Agreement.</li>
                <li>Click <strong>Next</strong>.</li>
              </ul>
              4. Enter your business contact details.
              <br />5. When asked for the app name, enter <strong>AgentZena</strong>.
              <br />6. Under <strong>API Products</strong>, turn on <strong>Tracking</strong>.
              <br />7. Click <strong>Save</strong> — your <strong>Client ID</strong> and <strong>Client Secret</strong> will be shown.
              <br />8. Copy them and paste into this dialog to connect UPS.
            </Typography>
          </Popover>
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 2 }}>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', pt: 4, gap: 2 }}>
            <TextField
              label="Client ID"
              value={form.clientId}
              onChange={onChange('clientId')}
              error={!!errors.clientId}
              helperText={errors.clientId}
              InputProps={{ startAdornment: <KeyIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
            />
            <TextField
              label="Client Secret"
              type="password"
              value={form.clientSecret}
              onChange={onChange('clientSecret')}
              error={!!errors.clientSecret}
              helperText={errors.clientSecret}
              InputProps={{ startAdornment: <SecurityIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
            />
          </Box>
        </DialogContent>
        {/* <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClose} color="inherit" disabled={connecting}>Cancel</Button>
          <Button onClick={onSubmit} variant="contained" disabled={connecting} startIcon={connecting ? <CircularProgress size={16} /> : null}>
            {connecting ? 'Connecting...' : 'Connect UPS'}
          </Button>
        </DialogActions> */}
      </Dialog>

      {/* Connection details dialog */}
      <Dialog open={detailsOpen} onClose={() => setDetailsOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid #e5e7eb', pb: 2, mb: 0 }}>
          <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#16a34a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <LocalShippingIcon sx={{ fontSize: 20, color: '#ffffff' }} />
          </Box>
          {/* <Typography variant="h6" sx={{ fontWeight: 600 }}>UPS Connection Details</Typography> */}
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, flex: 1 }}>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
              UPS Connection Details
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: '#6b7280' }}>
                  Get your UPS Client ID & Secret
                </Typography>
                <IconButton size="small" onClick={handleInfoOpen} sx={{ color: '#6b7280' }}>
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Box>
            </Box>
          </Box>

          <Popover
            open={infoOpen}
            anchorEl={infoAnchor}
            onClose={handleInfoClose}
            anchorOrigin={{ vertical: isMobile ? 'bottom' : 'center', horizontal: isMobile ? 'center' : 'right' }}
            transformOrigin={{ vertical: isMobile ? 'top' : 'center', horizontal: isMobile ? 'center' : 'left' }}
            sx={{ '& .MuiPaper-root': { p: 2, maxWidth: isMobile ? 'calc(100vw - 32px)' : 420, width: isMobile ? 'calc(100vw - 32px)' : 'auto' } }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
              Get your UPS Client ID & Secret
            </Typography>
            <Typography variant="body2" sx={{ color: '#374151', mb: 1 }}>
              1. Log in to the{' '}
              <MuiLink href="https://developer.ups.com" target="_blank" rel="noreferrer">
                UPS Developer Portal
              </MuiLink>.
            </Typography>
            <Typography variant="body2" sx={{ color: '#374151' }}>
              2. Go to <strong>My Apps → Add Apps</strong>.
              <br />3. On the first screen:
              <ul style={{ marginTop: 6, paddingLeft: 18 }}>
                <li>Select “I want to integrate UPS technology into my business.”</li>
                <li>Choose your UPS account from the dropdown.</li>
                <li>Check the box to agree to the UPS API Access Agreement.</li>
                <li>Click <strong>Next</strong>.</li>
              </ul>
              4. Enter your business contact details.
              <br />5. When asked for the app name, enter <strong>AgentZena</strong>.
              <br />6. Under <strong>API Products</strong>, turn on <strong>Tracking</strong>.
              <br />7. Click <strong>Save</strong> — your <strong>Client ID</strong> and <strong>Client Secret</strong> will be shown.
              <br />8. Copy them and paste into this dialog to connect UPS.
            </Typography>
          </Popover>
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 2 }}>
          <Grid container spacing={3} pt={4}>
            <Grid size={{ xs: 12, md: 12 }}>
              <TextField
                fullWidth
                label="Client ID"
                type={showDetailsId ? 'text' : 'password'}
                value={effectiveUser?.ups?.clientId || ''}
                InputProps={{
                  startAdornment: <KeyIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                  endAdornment: (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton onClick={() => setShowDetailsId(!showDetailsId)} edge="end" size="small">
                        {showDetailsId ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                      <IconButton onClick={() => navigator.clipboard.writeText(effectiveUser?.ups?.clientId || '')} edge="end" size="small" sx={{ ml: 0.5 }}>
                        <ContentCopyIcon />
                      </IconButton>
                    </Box>
                  )
                }}
                sx={{ '& .MuiInputBase-input': { color: '#6b7280' } }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <TextField
                fullWidth
                label="Client Secret"
                type={showDetailsSecret ? 'text' : 'password'}
                value={effectiveUser?.ups?.clientSecret || ''}
                InputProps={{
                  startAdornment: <SecurityIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                  endAdornment: (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton onClick={() => setShowDetailsSecret(!showDetailsSecret)} edge="end" size="small">
                        {showDetailsSecret ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                      <IconButton onClick={() => navigator.clipboard.writeText(effectiveUser?.ups?.clientSecret || '')} edge="end" size="small" sx={{ ml: 0.5 }}>
                        <ContentCopyIcon />
                      </IconButton>
                    </Box>
                  )
                }}
                sx={{ '& .MuiInputBase-input': { color: '#6b7280' } }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDetailsOpen(false)} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>

      {/* Disconnect confirmation dialog */}
      {/* <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Disconnect UPS?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mt: 1 }}>This will remove your UPS connection from this account.</Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setConfirmOpen(false)} color="inherit">Cancel</Button>
          <Button onClick={async () => { const res = await dispatch(disconnectUPS()); if (res?.success) { setConfirmOpen(false); dispatch(validateToken()); } }} variant="contained" color="error" disabled={connecting}>
            Disconnect
          </Button>
        </DialogActions>
      </Dialog> */}
    </Box>
  );
};

export default UPSIntegration;


